
import { useContext } from 'react';
import { CloseIcon } from '../ui/Icons/TooltipIcon';
import FrmProject from './frmProject';
import { PlanBuilderContext } from './Plan';
//import { Input } from '../ui/input';


interface ProjectBuilderProps {
  projectName: string
  projectTypeId: number
}

const ProjectBuilder = ({ projectName, projectTypeId }: ProjectBuilderProps) => {
  const props = useContext(PlanBuilderContext);
  return (
    <div className="flex flex-col border-2 border-gray-500 rounded-md ml-2 min-w-[450px] h-min">
      <div className="flex flex-row justify-between items-center px-2 py-1 bg-planbuilder-project-header text-planbuilder-workstream-header-foreground">
        <div>
          {projectName}
        </div>
        <div className='my-auto' onClick={() => props.setShowEditForm(false)} ><CloseIcon className="text-white rounded-md cursor-pointer hover:bg-red-500" /></div>
      </div>
      
      <div className="flex flex-col justify-between p-4">
        <FrmProject projectTypeId={projectTypeId} />
      </div>
    </div>
  )
}

export default ProjectBuilder